/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { action } from 'typesafe-actions';

import {
  checkoutActionTypes,
  checkoutData,
  checkoutDataSuccess,
  errorData,
  orderDataSuccess,
  ServicesCheckoutProps,
  CustomerProps,
  cartProductProps,
  checkoutDataResponseApi,
  IMethodPaymentSelected,
  IOrderCheckout,
} from './types';
import { CustomerData, User, UserAddresses, UserCard } from '../auth/types';
import { ServicesProps } from '../product/types';
import { Store, Locker } from '../parameter/types';

export function uploadCheckout() {
  return action(checkoutActionTypes.UPLOAD_CHECKOUT);
}

export function getCheckout() {
  return action(checkoutActionTypes.GET_CHECKOUT);
}

export function checkoutSucess(checkout: checkoutDataResponseApi) {
  return action(checkoutActionTypes.CHECKOUT_SUCESS, {
    checkout,
  });
}

export function checkoutFailure() {
  return action(checkoutActionTypes.CHECKOUT_FAILURE);
}

export function checkoutAddPlu(
  product_id: string,
  sellerId?: number,
  serviceId?: number,
  cartProduct?: cartProductProps[],
  observation?: string,
) {
  return action(checkoutActionTypes.ADD_PLU_CHECKOUT, {
    product_id,
    sellerId,
    serviceId,
    cartProduct,
    observation,
  });
}

export function updatePluQtyCheckout(
  cart_item_id: number,
  qty: string,
  observation?: string,
) {
  return action(checkoutActionTypes.UPDATE_PLU_QTY_CHECKOUT, {
    cart_item_id,
    qty,
    observation,
  });
}

export function checkoutRemovePlu(
  cart_item_id: number,
) {
  return action(checkoutActionTypes.REMOVE_PLU_CHECKOUT, {
    cart_item_id,
  });
}

export function checkoutSetShippingPrice(shipping: number) {
  return action(checkoutActionTypes.SET_SHIPPING_PRICE, {
    shipping,
  });
}

export function closeSale(
  id: string,
  summary: checkoutDataSuccess,
  user: User,
) {
  return action(checkoutActionTypes.CLOSE_SALE, {
    id,
    summary,
    user,
  });
}

export function closeSaleSucess(order: orderDataSuccess) {
  return action(checkoutActionTypes.CLOSE_SALE_SUCCESS, { order });
}

export function clearSale() {
  return action(checkoutActionTypes.CLEAR_SALE);
}

export function closeSaleFailure(error: errorData) {
  return action(checkoutActionTypes.CLOSE_SALE_FAILURE, {
    error,
  });
}

export function voidedSale() {
  return action(checkoutActionTypes.VOIDED_SALE);
}

export function voidedSaleSucess() {
  return action(checkoutActionTypes.VOIDED_SALE_SUCCESS);
}

export function checkPaymentRequest({ transactionId, isOrderPage = false }: { transactionId: string, isOrderPage?: boolean }) {
  return action(checkoutActionTypes.CHECK_PAYMENT_REQUEST, {transactionId, isOrderPage});
}

export function checkPaymentResponse() {
  return action(checkoutActionTypes.CHECK_PAYMENT_RESPONSE, {});
}

export function orderByIDRemake(order_id: number) {
  return action(checkoutActionTypes.ORDER_ID_REMAKE_REQUEST, { order_id });
}

export function orderByIDRemakeSuccess(checkout: checkoutData) {
  return action(checkoutActionTypes.ORDER_ID_REMAKE_SUCCESS, { checkout });
}

export function clearError() {
  return action(checkoutActionTypes.CLEAR_ERROR);
}

export function sendRequestNew(
  payload: {
    email: string,
    checkout: checkoutData | undefined,
    store: Store | undefined,
    address: UserAddresses | undefined,
    locker: Locker | undefined,
    method: UserCard | undefined,
    sellerId?: string,
    security_code?: string,
    payOnDelivery?: boolean,
    shippingMethod?: string,
    shippingDate?: string;
    windowsConfig: {
      width: number;
      height: number;
      colorDepth: number;
    }
  }
) {
  return action(checkoutActionTypes.SEND_REQUEST_NEW, payload);
}

export function sendRequestNewSuccess(order: orderDataSuccess) {
  return action(checkoutActionTypes.SEND_REQUEST_NEW_SUCCESS, { order });
}

export function setServicesCheckout(services: ServicesCheckoutProps) {
  return action(checkoutActionTypes.SET_SERVICES, { services });
}

export function deleteServicesCheckout(id: string) {
  return action(checkoutActionTypes.DELET_SERVICES, { id });
}

export function changeServicesCheckout(id: string, service: ServicesProps) {
  return action(checkoutActionTypes.CHANGE_SERVICES, { id, service });
}

export function verifyCustomerCardIsExist(cpfOrEmail: string, message: string) {
  return action(checkoutActionTypes.VERIFY_CUSTOMER_CARD_IS_EXIST, {
    cpfOrEmail,
    message,
  });
}

export function verifyCustomerCardIsExistSucess(customer: CustomerProps) {
  return action(checkoutActionTypes.VERIFY_CUSTOMER_CARD_IS_EXIST_SUCESS, {
    customer,
  });
}

export function updateCustomerCard(
  customer: CustomerData,
  idCustomerCard: string,
  message: string,
) {
  return action(checkoutActionTypes.UPDATE_CUSTOMER_CARD, {
    customer,
    idCustomerCard,
    message,
  });
}

export function logoutCustomerCardCheckout() {
  return action(checkoutActionTypes.LOGOUT_CUSTOMER_CARD, {});
}

export function createOrUpdateAddressCustomerCard(
  addresse: UserAddresses,
  idCustomerCard: string,
  customer_id: string,
  message: string,
) {
  return action(checkoutActionTypes.CREATE_OR_UPDATE_CUSTOMER_CARD, {
    addresse,
    idCustomerCard,
    customer_id,
    message,
  });
}

export function createOrUpdateAddressCustomerCardSucess() {
  return action(checkoutActionTypes.CREATE_OR_UPDATE_CUSTOMER_CARD_SUCESS, {});
}

export function setMethodPaymentSelected(input: IMethodPaymentSelected) {
  return action(checkoutActionTypes.METHOD_PAYMENT_SELECTED, input);
}

export function selectedAddressCustomerCard(
  address_id: number,
  idCustomerCard: string,
  customer_id: string,
  message: string,
) {
  return action(checkoutActionTypes.SELECT_ADDRESS_CUSTOMER_CARD, {
    address_id,
    idCustomerCard,
    customer_id,
    message,
  });
}

export function removeAddressCustomerCard(
  addresse: UserAddresses,
  customer_id: string,
  message: string,
) {
  return action(checkoutActionTypes.REMOVE_ADDRESS_CUSTOMER_CARD, {
    addresse,
    customer_id,
    message,
  });
}

export function removeAddressCustomerCardSucess() {
  return action(checkoutActionTypes.REMOVE_ADDRESS_CUSTOMER_CARD_SUCESS, {});
}

export function clearMessageCustomerCard() {
  return action(checkoutActionTypes.CLEAR_MESSAGE_CUSTOMER_CARD, {});
}

export function clearLoading() {
  return action(checkoutActionTypes.CLEAR_LOADING, {});
}

export function applyCoupon(
  coupon: string,
  messageError: string,
) {
  return action(checkoutActionTypes.APPLY_COUPON, {
    coupon,
    messageError,
  });
}

export function orderCheckoutResponse(orderCheckout: IOrderCheckout) {
  return action(checkoutActionTypes.ORDER_CHECKOUT_RESPONSE, { orderCheckout });
}

export function orderCheckoutClear() {
  return action(checkoutActionTypes.ORDER_CHECKOUT_CLEAR);
}
